<template>
    <div class="buttons buttons--podcast">
        <div class="buttons__side buttons__left">
            <button class="buttons__button buttons__mute" @click="mute()">
                <svg aria-hidden="true" data-prefix="far" data-icon="volume-slash" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-volume-slash fa-w-20 fa-lg" v-show="playerStatus.muted" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM370.23 179.13c-9.14-5-20.01-3.25-27.41 3.33l70.67 55.25c-5.31-24.49-20.57-46.09-43.26-58.58zm30.29-37.75C440.27 166.6 464 209.44 464 256c0 6.75-.64 13.38-1.61 19.93l41.66 32.57c5.03-16.82 7.95-34.39 7.95-52.5 0-63.09-32.06-121.09-85.77-155.16-11.19-7.09-26.03-3.8-33.12 7.41-7.09 11.21-3.78 26.03 7.41 33.13zm53.27-80.96c66.27 43.49 105.82 116.6 105.82 195.58 0 29.13-5.46 57.42-15.57 83.76l39.23 30.67C599.07 334.91 608 296.19 608 256c0-95.33-47.73-183.58-127.65-236.03-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.5zM288 88.02C288 73.51 276.13 64 263.81 64c-5.91 0-11.92 2.18-16.78 7.05l-20.5 20.49L288 139.59V88.02zm-48 278.03L177.94 304H80v-96h61.71l-61.4-48H56c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V322.37l-48-37.53v81.21z"/></svg>
                <svg aria-hidden="true" data-prefix="far" data-icon="volume-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="svg-inline--fa fa-volume-up fa-w-18 fa-3x" v-show="!playerStatus.muted" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M338.23 179.12c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.62 336 256c0 14.37-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.87s-17.54-61.33-45.78-76.88zM480 256c0-63.09-32.06-121.09-85.77-155.15-11.19-7.09-26.03-3.8-33.12 7.41s-3.78 26.03 7.41 33.12C408.27 166.59 432 209.44 432 256s-23.73 89.4-63.48 114.62c-11.19 7.09-14.5 21.92-7.41 33.12 6.51 10.28 21.12 15.03 33.12 7.41C447.94 377.09 480 319.09 480 256zM448.35 19.97c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51C488.06 103.91 527.61 177.02 527.61 256c0 78.98-39.55 152.08-105.82 195.57-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.57 576 351.33 576 256S528.27 72.42 448.35 19.97zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.86 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM208 366.04L145.94 304H48v-96h97.94L208 145.95v220.09z"/></svg>
            </button>

            <div class="buttons__button-container">
                <button class="buttons__button  buttons__change" @click="playPreviousEpisode()" v-show="prevEpisode">
                    <svg aria-hidden="true" data-prefix="far" data-icon="step-backward" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-step-backward fa-w-14 fa-fw fa-lg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M76 480h24c6.6 0 12-5.4 12-12V285l219.5 187.6c20.6 17.2 52.5 2.8 52.5-24.6V64c0-27.4-31.9-41.8-52.5-24.6L112 228.1V44c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v424c0 6.6 5.4 12 12 12zM336 98.5v315.1L149.3 256.5 336 98.5z"/></svg>
                </button>
            </div>
        </div>

        <button @click="togglePlay()" class="buttons__play">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-show="playerStatus.playing && !isStreaming" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm256 0v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-show="!playerStatus.playing || isStreaming" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>
        </button>

        <div class="buttons__side  buttons__right">
            <div class="buttons__button-container">
                <button class="buttons__button buttons__change" @click="playNextEpisode()" v-show="nextEpisode">
                    <svg aria-hidden="true" data-prefix="far" data-icon="step-forward" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-step-forward fa-w-14 fa-fw fa-lg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M372 32h-24c-6.6 0-12 5.4-12 12v183L116.5 39.4C95.9 22.3 64 36.6 64 64v384c0 27.4 31.9 41.8 52.5 24.6L336 283.9V468c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12zM112 413.5V98.4l186.7 157.1-186.7 158z"/></svg>
                </button>
            </div>

            <a class="buttons__button buttons__audiotheek" v-bind:href="currentDetailUrl">
                <svg aria-hidden="true" data-prefix="far" data-icon="list" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-list fa-w-16 fa-fw fa-lg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M80 48H16A16 16 0 000 64v64a16 16 0 0016 16h64a16 16 0 0016-16V64a16 16 0 00-16-16zm0 160H16a16 16 0 00-16 16v64a16 16 0 0016 16h64a16 16 0 0016-16v-64a16 16 0 00-16-16zm0 160H16a16 16 0 00-16 16v64a16 16 0 0016 16h64a16 16 0 0016-16v-64a16 16 0 00-16-16zm416-136H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16v-16a16 16 0 00-16-16zm0 160H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16v-16a16 16 0 00-16-16zm0-320H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16V88a16 16 0 00-16-16z"/></svg>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlayerButtons',
    props: [
        'streamUrl'
    ],
    data: function(){
        return {
            default: ''
        }
    },
    computed: {
        debug(){        return this.$store.state.player.debug; },
        isStreaming(){  return this.$store.state.player.current.url == this.streamUrl; },
        currentTrack(){ return this.$store.state.player.current; },
        currentShow(){  return this.$store.state.player.show; },
        currentEpisode(){ return this.$store.state.player.episode; },
        playerStatus(){ return this.$store.state.player.status; },
        currentDetailUrl() {
            if(this.currentShow == null || !this.currentEpisode) return;
            return "/podcast/uitzendingen/" + this.currentShow.slug;
        },
        prevEpisode()
        {  
            if(this.currentShow == null ||!this.currentEpisode) return;
            return this.currentEpisode.nr > 0; 
        },
        nextEpisode()
        {
            if(this.currentShow == null || !this.currentEpisode) return;
            return (this.currentShow.fields.broadcast_files.length - 1) > this.currentEpisode.nr; 
        },
    },
    watch: {
        playerStatus(newStatus, oldStatus){
          if(JSON.stringify(newStatus) != JSON.stringify(oldStatus)){
            if(this.debug) console.log('buttons:playerStatus updated') 
          }
        },
    },
    methods: {
        mute() {
            this.$store.dispatch('player/toggleMutePlayer', !this.playerStatus.muted);
        },
        openAudiotheek() {
            //console.log('OPEN AUDIOTHEEK')
        },
        togglePlay() {
            if(this.isStreaming) return this.$store.dispatch('player/setShow', this.currentShow);

            this.$store.dispatch('player/toggleStartPlayer');
        },
        playPreviousEpisode() {
            this.$store.dispatch('player/previousEpisode');
        },
        playNextEpisode() {
            this.$store.dispatch('player/nextEpisode');
        },
    }
}
</script>

<style lang="scss">
.buttons {
    padding: 1.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__side {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(50% - 3.5rem);

        &--end {
            justify-content: flex-end;
        }
    }

    button {
        &:before, &:after {
            content: none;
        }
    }

    &__button {
        background: none;
        border: none;
        padding: 0;
    }

    .icon { 
        width: 1.125rem;
        height: 1.125rem;

        path {
            fill: $c-primary-100;
        }
        
    }

    &__play {
        @include buttons-base;
        width: 4rem;
        height: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        border-radius: 50%;
        background: $c-secondary-100;
        color: #fff;
        cursor: pointer;
        padding: 0;

        .icon {
            width: 1.5rem;
            height: 1.5rem;

            path {
                fill: $c-white-100;
            }
        }
    }

    &__mute {
        background: $c-primary-10;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .625rem;
        padding: 0;

        svg {
            width: 1.125rem;
            height: 1.125rem;

            path {
                fill: $c-primary-100;
            }
        }
    }

    &__audiotheek {
        background: $c-primary-10;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .625rem;
        padding: 0;

        svg {
            width: 1.125rem;
            height: 1.125rem;

            path {
                fill: $c-primary-100;
            }
        }
    }

    &__change {
        background: none;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .625rem;
        padding: 0;

        svg {
            width: 1.125rem;
            height: 1.125rem;

            path {
                fill: $c-black-100;
            }
        }
    }
}
</style>